module.exports = __webpack_public_path__ + "static/media/redX.8a65a0f3.svg";